import { useApp } from 'AppProvider';
import { AppNavigationBar } from 'components/widgets/AppNavigationBar';
import React from 'react';
import HomePage from './ContentPages/HomePage';
import ContactUsPage from './ContentPages/ContactUsPage';
import EmergencyServicePage from './ContentPages/EmergencyServicePage';
import FaqPage from './ContentPages/FaqPage';
import SafetyGuidePage from './ContentPages/Resources/SafetyGuidePage';
import DocumentationPage from './ContentPages/Resources/DocumentationPage';
import ReportsPage from './ContentPages/Operations/ReportsPage';
import PartnersPage from './ContentPages/Services/PartnersPage';
import ChassisTrackingPage from './ContentPages/Services/ChassisTrackingPage';
import MaintenancePage from './ContentPages/Services/MaintainancePage';
import GalleryPage from './ContentPages/Resources/GalleryPage';


const HeaderPage = () => {
    const {navigateToPage} = useApp();
      const menuItems = [
    {
        label: 'Home',
        href: '/'
    },
    {
        label: 'Services',
        subItems: [
            {
                label: 'Chassis Tracking',
                href: '/services/tracking'
            },
            {
                label: 'Partners',
                href: '/services/container-transport'
            },
            {
                label: 'Reports',
                href: '/operations/reports'
            },
            {
                label: 'Maintenance',
                href: '/services/maintenance'
            }
        ]
    },
    // {
    //     label: 'Operations',
    //     subItems: [
    //         {
    //             label: 'Schedule Delivery',
    //             href: '/operations/schedule'
    //         },
    //         {
    //             label: 'Live Tracking',
    //             href: '/operations/live-tracking'
    //         }
    //     ]
    // },
    {
        label: 'Resources',
        subItems: [
            {
                label: 'Documentation',
                href: '/resources/docs'
            },
            {
                label: 'Safety Guidelines',
                href: '/resources/safety'
            },
            {
                label: 'Gallery',
                href: '/resources/safety'
            }
        ]
    },
    {
        label: 'Support',
        subItems: [
            {
                label: 'Contact Us',
                href: '/support/contact'
            },
            {
                label: 'Emergency Services',
                href: '/support/emergency'
            },
            {
                label: 'FAQ',
                href: '/support/faq'
            }
        ]
    }
];

    const handleMenuItemClick = (item) => {
        if (item === "Home") {
            console.log("Home clicked");
            navigateToPage(<HomePage />);
        } else if (item === "Contact Us") {
            console.log("Contact Us clicked");
            navigateToPage(<ContactUsPage />);
        } else if (item === "Emergency Services") {
            console.log("Services clicked");
            navigateToPage(<EmergencyServicePage />);
        } else if( item === "FAQ") {
            console.log("FAQ clicked");
            navigateToPage(<FaqPage />);
        } else if( item === "Safety Guidelines") {
            console.log("Safety Guidelines clicked");
            navigateToPage(<SafetyGuidePage />);
        } else if(item === "Documentation") {
            console.log("Documentation clicked");
            navigateToPage(<DocumentationPage />);
        } else if(item === "Reports") { 
            console.log("Reports clicked");
            navigateToPage(<ReportsPage />);
        } else if (item === "Partners") {
            console.log("Partners clicked");
            navigateToPage(<PartnersPage />);
        } else if (item === "Chassis Tracking") {
            console.log("Chassis Tracking clicked");
            navigateToPage(<ChassisTrackingPage />);
        } else if(item === "Maintenance") {
            console.log("Maintenance clicked");
            navigateToPage(<MaintenancePage />);
        } else if(item === "Gallery") {
            console.log("Gallery clicked");
            navigateToPage(<GalleryPage />);
        }

        console.log("Item clicked:", item);
    };

    return (
        <div>
            <AppNavigationBar title="Avis Logistics" menuItems={menuItems} onItemClick={handleMenuItemClick} />
        </div>
    );
};

export default HeaderPage;
